import React, { useMemo } from 'react';
import SeatingScreen from './SeatingScreen';
import { createSeatingApi } from '../../services/SeatingApiClient';
import { staffCredentials } from '../../services/DoorApiClient';
import { useRole } from '../../hooks/useRole';
import { useStoredEvents } from '../../hooks/useStoredEvents';

interface SeatingViewProps {
  eventId?: string | null;
  onEventChange?: (eventId: string) => void;
}

/** The Event Day Seating tab: the signed-in person's credentials, the project's events, and their role. */
const SeatingView: React.FC<SeatingViewProps> = ({ eventId, onEventChange }) => {
  const api = useMemo(() => createSeatingApi(staffCredentials), []);
  const { canEdit } = useRole();
  const events = useStoredEvents();
  const options = useMemo(() => events.filter((e) => !e.archived).map((e) => ({ id: e.id, title: e.title })), [events]);
  return <SeatingScreen api={api} eventId={eventId ?? null} events={options} onEventChange={onEventChange} canEdit={canEdit} />;
};

export default SeatingView;
